import { create } from "zustand";


const ZustandFormImovel = create((set, get) => ({
  tipoImovel: "",
  situacaoImovel: "Novo",
  valorDoImovel: "",
  valorFGTS: "",
  valorDeEntrada: "",
  prazoMeses: "",

  setTipoImovel: (value) => set({ tipoImovel: value }),
  setSituacaoImovel: (value) => set({ situacaoImovel: value }),
  setValorDoImovel: (value) => set({ valorDoImovel: parseFloat(value) || 0 }),
  setValorFGTS: (value) => set({ valorFGTS: parseFloat(value) || 0 }),
  setValorDeEntrada: (value) => set({ valorDeEntrada: parseFloat(value) || 0 }),
  setPrazoMeses: (value) => set({ prazoMeses: parseFloat(value) || 0 }),

  imovelErro: false,
  tipoImovelIsErro: false,
  situacaoImovelIsErro: false,
  valorDoImovelIsErro: false,
  valorEntradaIsErro: false,
  valorDeFinanciamento: false,
  prazoMesesIsErro: false,

  setImovelErro: (value) => set({ imovelErro: value }),
  setTipoImovelIsErro: (value) => set({ tipoImovelIsErro: value }),
  setSituacaoImovelIsErro: (value) => set({ situacaoImovelIsErro: value }),
  setValorDoImovelIsErro: (value) => set({ valorDoImovelIsErro: value }),
  setValorEntradaIsErro: (value) => set({ valorEntradaIsErro: value }),
  setPrazoMesesIsErro: (value) => set({ prazoMesesIsErro: value }),
}));

export default ZustandFormImovel;
